import {createSlice} from "@reduxjs/toolkit";
import {IRoute} from "../../Interfaces/IRoute";

const initialState: IRoute[] = [];
const menuItemSlice = createSlice({
  name: 'menu',
  initialState: initialState,
  reducers: {
    add(state, action) {
      state.pop()
      state.push(action.payload)
    },
    remove(state, action) {
      return state.filter((item) => item.name !== action.payload)
    }
  }
})

export const {add, remove} = menuItemSlice.actions;
export default menuItemSlice.reducer;